import { Component, Input, numberAttribute, OnInit, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';


@Component({
    selector: 'app-incrementor',
    imports: [FormsModule, InputGroupModule, InputGroupAddonModule, InputTextModule, ButtonModule],
    templateUrl: './incrementor.component.html',
    styleUrl: './incrementor.component.scss'
})
export class IncrementorComponent implements OnInit {

  @Input({ transform: numberAttribute }) value:number = 0;
  @Input({ transform: numberAttribute }) minValue:number = 0;
  @Input({ transform: numberAttribute }) maxValue:number = 4;
  @Input() hasMaxPersons:boolean = false;
  @Input() maxErrorText:string;
  @Input() dataTestId:string;
  onChange = output<number>();

  showMaxError:boolean = false;

  ngOnInit() {

  }

  add() {
    if (this.hasMaxPersons) {
      return;
    }
    if (this.value < this.maxValue) {
      this.value = this.value + 1;
      this.onChange.emit(this.value);
      this.showMaxError = false;
    }
    else {
      this.showMaxError = true;
    }
  }

  remove() {
    this.showMaxError = false;
    if (this.value > this.minValue) {
      this.value = this.value - 1;
      this.onChange.emit(this.value);
    }
  }
}
